module.exports = __webpack_public_path__ + "img/intro-video-icon.634cba0c.svg";